export default "__VITE_ASSET__D8Qooyrt__"